// hooks/downloads.js
const BASE = (process.env.REACT_APP_BASE_API_URL || "http://localhost:8000/api/").replace(
  /\/$/,
  ""
);

const pdf = (filename) => `${BASE}/pdfs/${filename}`;

export const handleDownloadTraForm = () => window.open(pdf("transport-form-najmath.pdf"));
export const handleDownloadASBT = () => window.open(pdf("Transport-form-ASBT.pdf"));
export const handleDUBAIBUSROUTES = () => window.open(pdf("BUS-ROUTE-MAP.pdf"));
export const handleDUBAIDRIVERDETAILS = () => window.open(pdf("DRIVER-DETAILS.pdf"));
export const handleTransportAlsaraya = () => window.open(pdf("transport-form-alsaraya.pdf"));
export const handleAgreementAlsaraya = () =>
  window.open(pdf("Alsaraya-PDS-Dubai-Transport-Agreement.pdf"));
export const handleDownloadNBT = () => window.open(pdf("Transport-form-NBT.pdf"));
export const handleDownloadSTAFFASBT = () => window.open(pdf("Transport-form-for-staff-ASBT.pdf"));
export const handleDownloadSTAFFNBT = () => window.open(pdf("Transport-form-for-staff-NBT.pdf"));
export const handleDownloadTraAgrForm = () => window.open(pdf("nbt-transport-agreement.pdf"));
export const handleDownloadTraAgrFormRAK = () => window.open(pdf("nbt-transport-agreement.pdf"));
export const handleDownloadDPSRAKRoutes = () => window.open(pdf("dps-rak-bus-routes.pdf"));
export const handleDownloadDPSSHJSNRRoutes = () =>
  window.open(pdf("BUS-ROUTES-DPS-SHARJAH-senior.pdf"));
export const handleDownloadDPSSHJPRIRoutes = () =>
  window.open(pdf("BUS-ROUTES-DPS-SHARJAH-primary.pdf"));
export const handleDownloadDPSRAKDRIVERDETAILS = () =>
  window.open(pdf("BUS-ROUTE-2023-2024-DPS-RAK.pdf"));
export const handleDownloadDPSRAKDD = () => window.open(pdf("dps-rak-bus-routes.pdf"));
export const handleDownloadDPSSHJSNRDD = () => window.open(pdf("DRIVER-DETAILS-DPS-SENIOR.pdf"));
export const handleDownloadDPSSHJPRIDD = () => window.open(pdf("DRIVER-DETAILS-DPS-PRIMARY.pdf"));
